import { render, staticRenderFns } from "./a12.vue?vue&type=template&id=ac81e434&scoped=true"
import script from "./a12.vue?vue&type=script&lang=js"
export * from "./a12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac81e434",
  null
  
)

export default component.exports